import React from 'react'
import styles from './styles.css'
import Text from 'orionsoft-parts/lib/components/fields/Text'

export default function TokenSmartCard(props) {
  const value = (typeof props.value === 'object' && props.value) || {}
  const onChange = (letter, letterFieldValue) => {
    const clean = letterFieldValue
      .replace(/[^0-9a-zA-Z]/g, '')
      .slice(0, 2)
      .toUpperCase()
    props.onChange(Object.assign({...value}, {[letter]: clean}))
  }

  const getLetters = (count = 0) => {
    const letters = []
    let i = 0
    while (i < count) letters.push(String.fromCharCode(65 + i++))
    return letters
  }

  const renderLetterField = letter => (
    <div key={letter} className={styles.letterField}>
      <Text
        value={value[letter]}
        label={letter}
        fieldName={`${props.fieldName}.${letter}`}
        passProps={props.passProps}
        onChange={letterFieldValue => onChange(letter, letterFieldValue)}
      />
    </div>
  )

  return (
    <div className={styles.container}>
      <div className={styles.mainText}>{props.label}</div>
      <br />
      {getLetters(15).map(letter => renderLetterField(letter))}
      {props.errorMessage ? <div className="os-input-error">{props.errorMessage}</div> : null}
    </div>
  )
}
